__turbopack_context__.v({
  "flatTerms": "FlatTerms-module-scss-module__b9OSmG__flatTerms",
  "flatTerms__svgClass": "FlatTerms-module-scss-module__b9OSmG__flatTerms__svgClass",
  "flatTerms__terms": "FlatTerms-module-scss-module__b9OSmG__flatTerms__terms",
  "flatTerms__title": "FlatTerms-module-scss-module__b9OSmG__flatTerms__title",
  "swiperButtonIconNext": "FlatTerms-module-scss-module__b9OSmG__swiperButtonIconNext",
  "swiperButtonNext": "FlatTerms-module-scss-module__b9OSmG__swiperButtonNext",
  "swiperButtonPrev": "FlatTerms-module-scss-module__b9OSmG__swiperButtonPrev",
});
